const initialState = {
  userInfo: {},
  userName: '',
}

const userInfo = (state = initialState, action = {}) => {
  if (action.type === 'USERINFO') {
    return { ...state, userInfo: action.payload }
  } else if (action.type === 'USERNAME') {
    return { ...state, userName: action.payload }
  } else {
    return state
  }
}

export default userInfo
